import React from "react";
import AddNoteCard from "./AddNoteCard";

function MyNotesEmptyState({ onAddNote }) {
  return (
    <section className="my-notes-empty-create" aria-labelledby="my-notes-empty-heading">
      <h2 id="my-notes-empty-heading" className="my-notes-empty-create-title">
        Create your first note
      </h2>
      <p className="my-notes-empty-create-text">
        You do not have any notes yet. Start by adding a note with text and optional documents.
      </p>
      <div className="my-notes-empty-create-action">
        <AddNoteCard onClick={onAddNote} />
      </div>
    </section>
  );
}

export default MyNotesEmptyState;
